import React, { Component } from 'react';

import {Pad} from '../../util';



class Timetable extends Component {

  renderTimeline () {
    const chList = JSON.parse(sessionStorage.getItem("chList"));
    let time = 0;
    const timeline = [];
    while(time < 25){
      timeline.push(
        <tr key={time}>
          <td className='timeline padding'></td>
          <td className='timeline'>{Pad.left(time, 2)}</td>
          <td className='timeline background'></td>
        </tr>
      )
      time++;
    }
    return timeline;
  }


  render() {
    return (
      <div className='list-wrapper'>
        <table className='timeline-container' ref={(i) => {this.timetable = i;}}>
          <tbody>
            {this.renderTimeline()}
          </tbody>
        </table>
      </div>
    )
  }


}

export default Timetable;


// WEBPACK FOOTER //
// ./src/components/timetable/Timetable.js